import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/investmentVehicles';

export default function InvestmentVehicles() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Everything in exam section 2.2: cash equivalents, fixed income, equity, pooled investments, derivatives, alternative investments, insurance-based products, and more."
      parts={parts}
    />
  );
}
